<template>
  <v-container id="citygroup-edit" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card>
          <template v-slot:heading>
            <div class="display-2 font-weight-light">{{$i18n.t("Compliances")}}</div>
          </template>

          <v-form id="form">
            <v-row>
              <v-col cols="12" md="12">
                <v-card>
                  <v-list-item-content calss="px-3">
                    <v-row>
                      <!-- <v-col cols="12" md="4" class="mx-3">
                          <h3>{{ $i18n.t("Tax Items") }}</h3>
                      </v-col>-->
                      <v-spacer />
                      <v-col clos="12" md="6">
                        <v-btn
                          @click="grid.rows = newItem(grid.rows)"
                          small
                          style="width:60px;float:right;"
                          color="light-blue"
                          text
                        >
                          <v-icon>mdi-plus</v-icon>
                          <h3>{{ $i18n.t("Add") }}</h3>
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-list-item-content>
                  <v-simple-table dense style="padding: 10px">
                    <thead>
                      <tr>
                        <th class="primary--text">{{ $i18n.t("Entity") }}</th>
                        <th class="primary--text">{{ $i18n.t("Guard Time") }}</th>
                        <th class="primary--text">{{ $i18n.t("Guard Allot Type") }}</th>
                        <th class="primary--text">{{ $i18n.t("Vehicle Max Age") }}</th>
                        <th class="primary--text">{{ $i18n.t("Vehicle Insurance") }}</th>
                        <th class="primary--text">{{ $i18n.t("Vehicle PUC") }}</th>
                        <th class="primary--text">{{ $i18n.t("Driver RC ") }}</th>
                        <th class="primary--text">{{ $i18n.t("Driver Police Verification") }}</th>
                        <th class="text-right primary--text">{{ $i18n.t("Action") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in grid.rows" :key="'item' + index">
                        <td>
                          <z-entity-select
                            v-model="item.entity_id"
                            :label="$i18n.t('Entity')"
                            corp="self"
                          />
                        </td>
                        <td>
                          <v-row>
                            <v-col cols="12" md="4">
                              <v-select
                                :items="guardTimes"
                                v-model="item.guardTime"
                                :label="$i18n.t('Guard Time')"
                                item-text="name"
                                item-value="value"
                              />
                            </v-col>
                            <v-col cols="12" md="4" v-if="item.guardTime == 2">
                              <z-time-picker
                                v-model="item.guardStartTime"
                                :label="$i18n.t('From')"
                              />
                            </v-col>
                            <v-col cols="12" md="4" v-if="item.guardTime == 2">
                              <z-time-picker v-model="item.guardEndTime" :label="$i18n.t('Till')" />
                            </v-col>
                          </v-row>
                        </td>
                        <td>
                          <v-select
                            :items="guardAllotTypes"
                            v-model="item.guardAllotType"
                            :label="$i18n.t('Guard Allot Type')"
                            item-text="name"
                            item-value="value"
                          />
                        </td>
                        <td>
                          <v-text-field v-model="item.carMaxAge" type="number" />
                        </td>
                        <td>
                          <v-checkbox v-model="item.carInsurance" />
                        </td>
                        <td>
                          <v-checkbox v-model="item.carPUC" />
                        </td>
                        <td>
                          <v-checkbox v-model="item.license" />
                        </td>
                        <td>
                          <v-checkbox v-model="item.policeVerified" />
                        </td>

                        <td>
                          <v-btn
                            class="float-right"
                            color="error"
                            small
                            fab
                            text
                            dark
                            v-if="!item._id"
                            @click="remove(grid.rows, index)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                          <z-confirm-button
                            class="float-right"
                            color="red lighten-1"
                            small
                            fab
                            text
                            v-if="item._id"
                            dark
                            :message="$i18n.t('Do you want to delete this compliance ?')"
                            @click="deletebu(item)"
                          >
                            <v-icon>mdi-trash-can-outline</v-icon>
                          </z-confirm-button>
                          <v-btn
                            color="info"
                            class="mr-0"
                            @click="save(item)"
                            :loading="loading"
                            small
                            fab
                            text
                          >
                            <v-icon>mdi-file</v-icon>
                          </v-btn>
                        </td>
                      </tr>
                      <v-spacer></v-spacer>
                    </tbody>
                  </v-simple-table>
                </v-card>
              </v-col>
            </v-row>
          </v-form>
          <v-container>
            <v-row justify="center">
              <v-col cols="8">
                <v-container class="max-width">
                  <v-pagination
                    v-model="grid.page"
                    class="my-4"
                    :length="grid.total"
                    total-visible="10"
                    @input="showPage"
                  ></v-pagination>
                </v-container>
              </v-col>
            </v-row>
          </v-container>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Tickets extends Vue {
  grid = { page: 0 };
  rows = 20;
  url = "/api/compliance/grid?rows=" + this.rows;
  guardAllotTypes = [
    { value: 1, name: "For All" },
    { value: 2, name: "Only if is female passenger present" },
    { value: 3, name: "Only if last drop/first pick up is not male" },
  ];
  guardTimes = [
    { value: 1, name: "Always" },
    { value: 2, name: "Only during specified Time" },
  ];

  get loading() {
    return common.loading;
  }

  async save(compliance) {
    try {
      common.setLoading(true);
      compliance = await doPost("/api/compliance/save", compliance);
      common.setLoading(false);
      this.search();
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
    }
  }

  async mounted() {
    common.setLoading(true);
    try {
      this.grid = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  async showPage(page) {
    this.page = page;
    this.grid = await doGet(this.url + this.filterUrl + "&page=" + page);
    common.setLoading(false);
  }

  async search() {
    this.filterUrl = "";
    common.setLoading(true);
    await this.showPage(1);
  }

  async deletebu(bu) {
    try {
      await doGet("/api/compliance/" + bu._id + "/delete");
      common.showMessage("Deleted Successfully");
      await this.search();
    } catch (e) {
      common.setError(e.message);
    }
    common.setLoading(false);
  }

  newItem(itemList) {
    if (!itemList) itemList = [];
    itemList.push({});
    return itemList;
  }

  remove(list, _index) {
    list.splice(_index, 1);
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
</style>
